import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewHotelero = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'hotelero',
        name: 'Hotelero',
        component: ViewHotelero,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
